module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_date":"Edit date","select":"Select","date":"date"},"id":{"edit_date":"Mengubah tanggal","select":"Pilih","date":"tanggal"}}')
  delete Component.options._Ctor
}
